var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLuvQueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 50,
    viewBox: "0 0 377.68 383.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        font-size: 28.44px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        font-family: Bahnschrift, Bahnschrift;\r\n        font-variation-settings: 'wght' 400, 'wdth' 100;\r\n      }\r\n\r\n      .cls-2 {\r\n        font-size: 24.52px;\r\n      }\r\n\r\n      .cls-3 {\r\n        font-family: Constantia-Bold, Constantia;\r\n        font-size: 34px;\r\n        font-weight: 700;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pig"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.9,103.97c-.82,0-7.54-6.34-9.42-9.26.32-.42.66-.87.66-.87-1.62-.87-3.56-1.49-4.96-2.72-13.26-11.69-27.89-21.18-44.2-28.02-28.88-12.11-58.81-15.95-89.82-11.57-28.61,4.03-54.4,14.75-77.22,32.49-20.81,16.18-36.89,36.22-47.96,60.13-6.19,13.38-10.73,27.34-12.93,41.98-.12.78-.22,1.57-.4,2.34-.41,1.77-1.79,2.81-3.41,2.61-1.63-.19-3.05-1.74-2.83-3.47.36-2.87.86-5.73,1.45-8.57,5.21-25.09,15.3-47.99,30.77-68.46,10.49-13.87,22.92-25.73,37.04-35.88,14.96-10.76,31.28-18.76,48.91-24.01,18.32-5.46,37.06-7.94,56.2-7.22.26,0,.51.07,1.04.15-.37.74-.68,1.38-.9,1.83l2.81.19c-.19-.53-.41-1.16-.69-1.96.73,0,1.35-.03,1.98.01,27.51,1.58,53.28,9.01,77.16,22.84,13.08,7.58,24.78,16.93,35.49,27.57.83.82,1.09,1.43-.15,2.19.09.14.19.27.28.41.51-.11,1.03-.21,1.99-.41.18.6.49,1.61.63,2.06,1.14.66,2.19.98,2.83,1.69,10.21,11.39,18.87,23.83,25.65,37.59,7.88,15.97,13.03,32.77,15.77,50.34.4,2.6-.48,4.13-2.61,4.44-1.92.28-3.31-.97-3.67-3.49-2.78-19.53-9.17-37.85-18.73-55.06-5.52-9.93-12.11-19.14-19.6-27.69-.46-.52-.66-1.26-1.14-2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.42,277.44c-.62.04-1.24.09-2.11.15.64-1.54,1.23-2.97,1.82-4.4,4.09-9.82,7.36-19.89,9.39-30.34.46-2.37,1.78-3.51,3.69-3.24,1.96.28,2.98,1.86,2.5,4.37-1.74,9.22-4.44,18.16-7.81,26.91-9.01,23.39-22.8,43.54-41.03,60.7-.95.9-1.79,1.93-2.88,3.12-.45-1.12-.64-1.59-.85-2.11-1.28.6-2.11,1.28-1.53,2.88.14.39-.37,1.19-.79,1.56-15.16,13.06-32.03,23.29-50.79,30.32-18.29,6.85-37.21,10.39-56.74,11.1-21.4.78-42.19-2.24-62.4-9.19-21.38-7.36-40.56-18.58-57.27-33.84-5.48-5.01-10.5-10.52-15.72-15.82-.41-.41-.72-.92-1.12-1.43.4-.52.74-.95,1.2-1.53-1.05-.37-1.94-.69-2.81-1,.23-.49.52-1.13.81-1.76-.15-.09-.29-.19-.44-.28-.5.33-.99.67-1.73,1.16-2.78-3.89-5.6-7.68-8.26-11.59-12.03-17.72-20.22-37.06-24.39-58.08-.15-.77-.34-1.56-.33-2.34.02-1.54.76-2.69,2.33-3.02,1.52-.32,2.75.25,3.43,1.68.33.7.55,1.48.71,2.25,5.75,28.33,18.79,52.95,37.88,74.5,1.39,1.57,2.72,3.2,4.16,4.9-.38.21-.75.42-1.13.63l-.06.52c.71.05,1.46-.03,2.12.18.65.21,1.24.67,1.77,1.12,5.66,4.83,11.12,9.9,16.98,14.46,10.86,8.47,22.87,15.04,35.61,20.28,1.42.58,2.57,1.82,4,2.4,1.27.52,2.79.39,4.12.82,15.14,4.95,30.63,8.04,46.56,8.73,4.14.18,8.3.08,12.45.18.7.02,1.39.45,2.03.67.64-.24,1.37-.72,2.12-.77,20.97-1.31,41.18-5.91,60.42-14.38,20.34-8.96,37.99-21.76,53.22-37.93,10.37-11.01,18.93-23.28,25.87-36.7.33-.64.81-1.22,1.06-1.89.59-1.54,1.04-3.14,3.23-2.92.27.03.59-.39.88-.6-.06-.15-.13-.29-.19-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.87,189.23c1.1.67.9,1.07,1.05,1.54.33,1.3.45,2.67.3,3.97-.44,5.1-.88,10.19-1.06,15.3-.64,20.44,4.2,40.99,14,58.96,39.53,71.87,137.61,81.59,190.83,19.35,0,0,3.28-3.96,3.28-3.96,1.54-1.97,3.04-4.24,4.59-6.21.99-1.42,2.04-2.78,3.2-4.08,0,0,.89-.98.89-.98.29-.33.71-.58,1.67-.53,0,0,.14.08.14.08.87,1.27.11,1.89-.21,2.94-.9,2.41-2.33,4.92-3.84,7.01-1.69,2.51-4.44,6.14-6.43,8.51-7.31,8.89-16.07,16.79-25.66,23.17-58.71,39.24-139.55,19.46-173.48-42.55-12.01-21.92-17.34-47.74-14.11-72.58.6-3.09.79-6.4,2.7-9.03.32-.39.29-.85,1.57-1.03,0,0,.58.12.58.12h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(49.71 281.85) rotate(-116.43) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(46.95 276.32) rotate(-114.16) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(44.41 270.66) rotate(-111.88) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(42.11 264.94) rotate(-109.59) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(40.03 259.11) rotate(-107.3) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(38.19 253.2) rotate(-105.02) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(36.58 247.35) rotate(-101.25) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(35.21 243.01) rotate(-81.08) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(34.12 239.11) rotate(-56.42) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(33.65 236.32) rotate(-29.5) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(34.23 234.39) rotate(-2.51) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(35.65 233.84) rotate(25.19) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(37.93 235.33) rotate(49.1) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(40.36 238.36) rotate(70.63) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(42.07 244.24) rotate(75.24) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(43.83 250.86) rotate(72.69) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(45.86 257.36) rotate(70.12) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(48.2 263.77) rotate(67.55) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(50.81 270.08) rotate(65) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(53.7 276.25) rotate(62.49) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(56.86 282.3) rotate(60.02) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(60.27 288.19) rotate(57.62) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(63.93 293.94) rotate(55.3) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(67.8 299.12) rotate(56.95) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(71.61 304.67) rotate(53.17) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(84.15 318.7) rotate(42.16) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(97.19 330.69) rotate(35.39) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(111.46 340.63) rotate(29.03) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(128.37 349.95) rotate(20.62) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(147.5 356.68) rotate(15.02) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(155.43 358.98) rotate(10.29) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(173.45 362.42) rotate(1.61) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(196.24 363.32) rotate(-6.2) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(214.66 361.43) rotate(-11.67) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "K")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(233.36 357.45) rotate(-18.37) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(250.16 351.85) rotate(-25.23) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(267.18 343.51) rotate(-30.45) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(274.45 339.45) rotate(-35.52) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(289.87 328.33) rotate(-42.32) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(303.56 315.85) rotate(-48.87) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M296.26,213.44c-16.2,17.3-34.72,23.31-49.78,18.68,7.01-3.3,12.9-5.79,18.51-8.8,5.55-2.99,10.82-6.51,16.21-9.8-.35-.86-.7-1.71-1.05-2.57-4.86.72-9.73,1.34-14.56,2.2-4.11.73-6.57-.5-7.31-5.49,4.84,0,9.27.17,13.69-.03,23.58-1.07,37.91-26.17,27.31-47.21-4.05-8.04-8.39-9.37-17.47-4.96-5.39,2.61-10.24,6.32-14.88,9.25-1.97,3.03-3.49,6.25-5.86,8.62-.99.99-3.78.17-5.75.18.55-2.11.67-5.8,1.71-6.08,6.34-1.71,7.67-7.31,10.45-11.89,8.24-13.56,22.58-15.9,34.83-5.78,14.07,11.63,16.49,32.52,5.63,48.71-1.36,2.03-2.79,4.02-4.16,6,13.99,15.5,8.67,41.72-3.89,53.77-10.8,10.37-23.09,19.35-35.46,27.87-10.34,7.12-20.12,14.62-28.03,24.34-9.71,11.93-22.61,18.03-37.4,19.79-8.77,1.04-17.85,1-26.62,0-8.69-.99-16.35-4.92-19.56-14.08,9.78,2.31,19.42,5.08,29.23,6.75,10.01,1.7,20.08,1.38,30.7-3.75-19.22-3.62-39.87-1.97-49.56-23.65,6.31-2.39,10.47.63,14.78,3.33,5.17,3.23,10.08,7.55,15.75,9.17,15.22,4.33,27.18-2.55,37.7-13.05,2.16-2.16,4.9-4.12,7.74-5.15,23.76-8.54,42.86-22.26,53.9-45.88,4.5-9.63,2.78-19.41,3.21-30.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.65,223.3c-.49,11.15-.94,21.28-1.38,31.42-.66.02-1.33.05-1.99.07-3.79-7.34-7.58-14.67-11.37-22.01-.85.45-1.7.9-2.55,1.36,2.04,3.6,4.08,7.19,6.47,11.42-10.43.94-11.76-13.96-22.66-11.65.63,14.4,12.43,17.35,23.06,22.88-6.11,3.49-11.94,3.59-17.24,1.52-14.08-5.5-19.81-17.31-22.05-31.73-7.77-1.85-11.59,3.56-15.97,8.39-2.94,3.25-6.4,6.1-9.99,8.61-.82.57-3.91-.53-4.66-1.69-3.01-4.68-1.26-12.83,3.67-15.67,6.32-3.65,12.92-6.94,19.67-9.71,8.86-3.63,17.01-7.82,21.8-16.72.56-1.05,2.75-2,3.89-1.74,1.15.27,2.31,1.97,2.78,3.3.44,1.25.5,3.17-.19,4.18-5.03,7.47.98,9.23,5.84,10.9,8.02,2.76,16.25,4.92,22.87,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.38,213.95c-6.3-11.86,4.5-15.68,7.95-22.29-.12-.52-.07-1.04-.31-1.26-15.19-14.43-13.28-29.03-.87-44.95,3.38-4.34,6.88-8.71,10.98-12.32,2.76-2.43,6.66-3.55,10.54-4.55-.23,8.3-4.77,13.7-9.34,19.03-3.57,4.18-7.14,8.39-11.09,12.2-5.06,4.89-3.64,9.76-.68,14.81,5.25,8.98,14.25,12.53,23.38,15.58,9.61,3.21,19.49,5.61,29.06,8.94,4.48,1.56,8.49,4.46,13.1,6.96-6.97,5.92-13.1,11.12-19.51,16.56-7.65-12.46-20.19-16.65-32.47-20.7-2.74-.9-7.07,1.69-10.16,3.53-3.57,2.13-6.58,5.2-10.58,8.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.5,121.63c6.71-3,12.17-.06,17.55,2.75,5.78,3.01,11.15,7.06,17.21,9.22,6.09,2.17,12.8,2.57,20.89,4.05-6.77-15.33-21.92-19.62-30.44-30.99.61,2.63,1.23,5.26,1.84,7.89-.43.38-.86.77-1.28,1.15-4.3-3.78-8.96-7.23-12.82-11.42-8.29-9-11.54-9.96-23.41-1.44-3.27,2.34-6.07,5.34-9.29,8.22-.76-10.97,12.18-23.64,25.03-20.77,18.58,4.15,32.63,15.37,46.11,27.66,5.56,5.07,10.51,10.82,15.71,16.23-3.14,5.38-7.38,7.63-13,7.24-4.86-.34-9.71-.84-14.56-1.15-2.65-.17-5.71-.96-7.91.04-8.43,3.83-12.88-1.26-17.87-6.59-3.99-4.26-8.79-7.76-13.77-12.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.93,122.4c-.69-6.28,1.69-11.24,5.43-15.75,3.25-3.92,6.47-7.87,9.77-11.75.56-.66,1.89-1.6,2.12-1.42.83.63,2.04,1.87,1.86,2.54-.68,2.46-1.57,4.97-2.92,7.11-1.92,3.04-4.32,5.78-6.58,8.74,11.85,3.33,23.24,5.94,34.21,9.75,18.64,6.46,30.33,19.26,32.87,39.39.25,1.99.03,4.03.03,6.47-5.08-.49-8.04-3.49-10.22-7.56-.57-1.07-1.17-2.19-1.41-3.36-4.69-22.58-21.93-28.44-41.49-31.16-7.79-1.09-15.61-1.98-23.67-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.03,302.74c-10.07,2.19-18.48-.99-26.13-6.14-23.34-15.71-36.01-50.48-28.48-77.33.44-1.57.77-3.23,1.57-4.61.51-.88,1.78-1.33,2.7-1.98.63.93,1.74,1.83,1.79,2.79.19,3.47-.02,6.95,0,10.43.26,33.32,15.87,57.38,44.43,73.62,1.06.61,2.2,1.09,3.28,1.67.15.08.19.34.83,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.44,179.37c-6.38,8.7-12.57,14.62-22.62,15.95,0-6.33.63-12.61-.13-18.7-1.56-12.48-9.32-21.85-16.76-31.41-4.1-5.26-7.41-11.16-10.71-16.99-1.09-1.93-1.03-4.51-1.83-8.41,19.8,16.45,36.05,33.18,39.97,58.32.58,3.73,2.72,4.15,5.67,3.4,1.7-.43,3.34-1.12,6.41-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.23,126.69c-6.07-4.65-11.37-8.61-16.56-12.71-7.64-6.05-11.99-5.47-17.36,2.78-2.97,4.56-5.63,9.34-8.52,14.18-7.18-8.7-.56-24.6,10.86-27.43,13.07-3.24,28.53,6.18,31.78,19.4.18.72-.06,1.53-.2,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.44,175.49c-7.02,6.13-13.93,12.16-20.85,18.19-.79-.48-1.58-.96-2.37-1.45,1.24-4.1,2.47-8.19,3.72-12.32-6.47,2.17-10.82,9.58-19.03,9.27,5.84-17.66,25.88-25.12,38.53-13.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.29,269.28c9.33,4.41,17.58-.18,26.12-2.21,3.69-.88,6.45-.68,5.21,4.2-1.35,5.35-9.78,10.09-17,9.78-8.4-.35-12.75-3.73-14.33-11.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,189.75c2.29-6.81,4.21-13.62,6.91-20.11,1.44-3.47,4.19-3.68,6.24.04,2.17,3.95-.58,22.12-4.16,24.95-1.55,1.23-4.72,2.32-5.97,1.55-1.57-.96-1.94-3.9-3.01-6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.49,178.13c.22-3.62.4-6.4.57-9.19-.4-.22-.8-.45-1.2-.67-1.52,1.85-3.03,3.71-4.95,6.05-1.37-1.5-3.2-3.07-4.48-4.99-2.37-3.55-3.02-7.32.97-10.22,3.72-2.71,8.3-3.27,10.8.85,2.86,4.72,5.56,10.25,5.92,15.6.49,7.19-4.7,2.47-7.63,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.04,122.57c-5.07-5.49-5.17-10.66-1.37-15.19,4.77-5.7,10.33-10.74,16.12-15.66-.2,12.41-10.78,19.51-14.75,30.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.82,168.96c-3.97-.96-6.36-1.54-9.91-2.4-.27.24-1.69,1.48-3.18,2.79-.52-.27-1.19-.42-1.54-.83-4.52-5.29-5.57-11.14-2.46-13.44,3.27-2.42,10.68.7,13.7,5.93,1.08,1.87,1.73,3.99,3.39,7.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.89,181.07c1.46-3.2,2.73-6.51,4.48-9.55.51-.9,2.69-1.75,3.5-1.36,1.23.59,2.73,2.3,2.71,3.51-.08,4.22-.44,8.51-1.4,12.61-.34,1.45-2.83,3.44-4.16,3.32-1.44-.14-2.99-2.28-3.9-3.88-.63-1.11-.24-2.78-.31-4.21-.3-.15-.61-.3-.91-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.1,143.31c-1.02-10.69,5.44-17.46,13.52-14.17-4.64,13.22-6.35,15.01-13.52,14.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.63,207.08c-.26-4.21-2-9.02,4.02-10.28,1.39-.29,4.71,2.11,4.83,3.46.5,6.03-4.35,6.19-8.85,6.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.99,200.01q-5.86-.21-5.4-6.46c5.18-.27,5.41,0,5.4,6.46Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(117.56 96.31) rotate(-22.68)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(134.16 89.07) rotate(-15.63)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "U")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(158.54 82.28) rotate(-7.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "V")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(179.74 79.59) rotate(-2.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(187.26 78.64) rotate(3.25)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(214.54 80.24) rotate(11.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "U")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(239.38 86.11) rotate(18.34)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(258.62 93.76) rotate(17.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hearts"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.43,205.22c5.52-4.26,12.49-4.06,16.09.3,2.78,3.36,2.85,8.1.38,11.7-3.47,5.06-8.93,7.66-13.59,11.29-3.28,2.56-5.73,2.04-8.38-.56-3.74-3.66-8-6.92-11.16-11.01-4.71-6.1-1.9-13.57,4.54-15.42,3.46-.99,7.83.26,12.12,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.06,205.83c5.09-4.77,12.04-5.25,16.04-1.26,3.09,3.08,3.62,7.79,1.51,11.61-2.96,5.37-8.15,8.49-12.43,12.55-3.02,2.87-5.51,2.58-8.4.26-4.08-3.28-8.63-6.11-12.17-9.88-5.28-5.62-3.21-13.32,3.02-15.78,3.35-1.32,7.81-.5,12.42,2.51Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuvQueLogo);
export default __webpack_public_path__ + "static/media/LUV_QUE_LOGO.e53139a4324681623f3fec87d5cf0acf.svg";
export { ForwardRef as ReactComponent };